import { Card, CardBody } from 'reactstrap';
import cx from 'classnames';

/**
 * KPI-Karte für Dashboards. Stilistisch aligned mit ArchitectUI-Card-Pattern,
 * aber dependency-frei (keine react-countup-Animation, weil das Package mit
 * den React-19-Peer-Deps zickt).
 */
export function KpiCard({ label, value, sublabel, accent = 'primary', icon }) {
  return (
    <Card className="kpi-card h-100">
      <CardBody>
        <div className="d-flex align-items-start justify-content-between">
          <div>
            <div className="text-uppercase small text-muted fw-semibold">
              {label}
            </div>
            <div className="display-6 fw-bold mt-1">{value}</div>
            {sublabel && (
              <div className="small text-muted mt-1">{sublabel}</div>
            )}
          </div>
          {icon && (
            <div
              className={cx(
                'rounded-circle d-flex align-items-center justify-content-center',
                `bg-${accent}-subtle text-${accent}`,
              )}
              style={{ width: 48, height: 48 }}
              aria-hidden
            >
              <i className={cx('icon', icon)} style={{ fontSize: 24 }} />
            </div>
          )}
        </div>
      </CardBody>
    </Card>
  );
}
